import script from "./ReservationTable.vue?vue&type=script&lang=js"
export * from "./ReservationTable.vue?vue&type=script&lang=js"

import "./ReservationTable.vue?vue&type=style&index=0&id=e8dd7516&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8dd7516"]])

export default __exports__